// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Urnqy","question":"styles_question__3Xwag","description":"styles_description__1Xpry"};